module.exports = __webpack_public_path__ + "img/9.eaad8a8d.png";